import { AssistantState } from '../reducers/assistant.reducer';
import { FormContainer } from '@eBeihilfe/einreichung-shared/model';
import { Injectable, Signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { assistantActions } from '../actions';
import { selectCurrentStep, selectDataPrivacyAccepted, selectIsCurrentStepLast } from '../selectors';

@Injectable()
export class AssistantFacade {
  private readonly store: Store<AssistantState> = inject(Store);

  public setDataPrivacyAccepted(accepted: boolean): void {
    this.store.dispatch(assistantActions.setDataPrivacyAccepted({ accepted }));
  }

  public navigateToStepByIndex(stepIndex: number): void {
    this.store.dispatch(assistantActions.navigateToStepByIndex({ index: stepIndex }));
  }

  public navigateToNextStep(): void {
    this.store.dispatch(assistantActions.navigateToNextStep());
  }

  public navigateToPreviousStep(): void {
    this.store.dispatch(assistantActions.navigateToPreviousStep());
  }

  public selectContainer(container: FormContainer): void {
    this.store.dispatch(assistantActions.selectContainer({ selectedContainerId: container.id }));
  }

  public closeAssistant(): void {
    this.store.dispatch(assistantActions.closeAssistant());
  }

  public clearStore(): void {
    this.store.dispatch(assistantActions.clearStore());
  }

  public selectDataPrivacyAccepted(): Signal<boolean> {
    return this.store.selectSignal(selectDataPrivacyAccepted);
  }

  public selectCurrentStepIndex(): Signal<number> {
    return this.store.selectSignal(selectCurrentStep);
  }

  public selectIsCurrentStepLast(): Signal<boolean> {
    return this.store.selectSignal(selectIsCurrentStepLast);
  }
}
